































































































































import gsap from 'gsap';
import { Place, PhysicalAddress } from 'inscreva-sse-models';
import moment from 'moment';
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';

import { Event } from '../models/event';
import EventFilter from './EventFilter.vue';
import PaginationComponent from './Pagination.vue';

@Component({
  components: {
    PaginationComponent,
    EventFilter,
  },
})
export default class EventListComponent extends Vue {
  @Prop({ required: true })
  events!: Array<Event>;

  @Prop({ required: true })
  private selected!: Event;

  @Emit()
  onEdit(event: Event) {
    return event;
  }

  @Emit()
  onSelect(event: Event) {
    return event;
  }

  isSelected(event: Event): boolean {
    return this.selected._id === event._id;
  }

  onVisualize(event: Event) {
    this.$emit('on-visualize', event);
  }

  isActive(event: Event): boolean {
    return event.active !== false;
  }

  @Emit()
  onActiveStatusChange(event: Event) {
    return event;
  }

  getFormattedDate(date: string, onlyHour?: boolean): string {
    return (date && moment(date).format(`${!onlyHour ? 'DD/MM/YYYY ' : ''}HH:mm`)) || '';
  }

  isPlaceAddress(place: Place): place is PhysicalAddress {
    return !!Object.keys((place as PhysicalAddress).address || {}).length;
  }

  getPlace(event: Event) {
    const place = typeof event.info.place === 'string' ? event.info.place : event.info.place.name;
    return !this.isPlaceAddress(event.info.place)
      ? place
      : `${place}, ${event.info.place.address.city}, ${event.info.place.address.state}`;
  }

  isEventFull(event: Event & { subscriptionCount: number }): boolean {
    return event.info.maxAttendees === event.subscriptionCount;
  }

  // PAGINATION
  page: number = 0;

  pageSize = 20;

  get eventsPage() {
    return this.events.slice(this.page * this.pageSize, (this.page + 1) * this.pageSize);
  }

  changePage(page: number) {
    this.page = page - 1;
  }

  // TRANSITIONS
  beforeEnter = (element: HTMLLIElement) => {
    element.style.opacity = '0';
    element.style.transform = 'translateY(50px)';
  };

  enter = (element: HTMLLIElement, done: any) => {
    gsap.to(element, {
      opacity: 1,
      y: 0,
      duration: 0.3,
      onComplete: done,
      delay: (element.dataset.index as unknown as number) * 0.1,
    });
  };
}
